// 3rd party
import { Directive, Input, ElementRef, Renderer, OnChanges } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[focus]'
})
export class FocusDirective implements OnChanges {

  @Input('focus') focus: boolean;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer
  ) { }

  ngOnChanges() {
    if (this.focus) {
      this.renderer
        .invokeElementMethod(this.elementRef.nativeElement, 'focus', []);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/directives/focus.directive.ts